import { createContext, useState, useEffect } from 'react';
import { updateLanguagePreference } from '~/update-language-preference';
import { getUserIdFromStore } from '~/utils/tracking';
import { LDClient, LDFlags } from '../launch-darkly';

/**
 * This code creates a custom React Provider component that creates a LocalizeContext object
 * and sets a language state. The language state is set by the Localize API and is used to
 * determine the language of the page. The language state is then passed to the LocalizeContext
 * object and can be used by any component that uses the LocalizeContext component.
 */

export const LocalizeContext = createContext('en');

export const LocalizeProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const ffAllowLanguageUpdateApi = LDClient.variation(LDFlags.ffAllowLanguageUpdateApi);

  useEffect(() => {
    const userId = getUserIdFromStore();

    const updateUserLanguageSelection = async userId => {
      await updateLanguagePreference({ userId, language });
    };

    if (ffAllowLanguageUpdateApi && userId) {
      updateUserLanguageSelection(userId);
    }
  }, [language]);

  if (window && window.Localize) {
    window?.Localize.on('setLanguage', function (locale: { to: string }) {
      // The locale.to property is the language code of the page, which is set by the Localize API
      setLanguage(locale.to);
    });
  }
  return <LocalizeContext.Provider value={language}>{children}</LocalizeContext.Provider>;
};
